import { render, staticRenderFns } from "./monthly-price.vue?vue&type=template&id=54bce45e"
import script from "./monthly-price.vue?vue&type=script&lang=js"
export * from "./monthly-price.vue?vue&type=script&lang=js"
import style0 from "./monthly-price.vue?vue&type=style&index=0&id=54bce45e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports